import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from "./plugins/vuetify"
import VueI18n from 'vue-i18n'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import * as firebase from "firebase"
import { translations } from './translations.js'
import { firebaseConfig } from './firebaseConfig.js'
import VueCurrencyInput from 'vue-currency-input'
import '@/assets/scss/main.scss'

Vue.use(vuetify)
Vue.use(VueI18n)
Vue.use(VueCurrencyInput)

Vue.config.productionTip = false

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

const i18n = new VueI18n({
  locale: 'es',
  messages: translations
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
